import React, { FC } from "react";
import ServiceTooltips from "containers/Storage/components/ServiceTooltip/ServiceTooltips";
import { IconType } from "enums/Icon";
import { List } from "immutable";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { getAddonsIconsImage } from "../../containers/Delivery/deliveryHelper";
import { servicesSelectAddonsAll } from "../../reduxFolder/selectors/servicesSelectors";
import CopyToClipboard from "../CopyToClipboard/CopyToClipboard";
import Icon from "../Icon/Icon";
import Logo from "../Logo/Logo";
import {
  AddonIcons,
  Comment,
  DetailedButton,
  ItemContent,
  ItemName,
  ItemQuantity,
  ListItem,
  ListWrapper,
  OpenItemWrapper,
  RightArrowIcon,
  ServiceRequests,
  TrackingNumber,
} from "./PackagesList.styles";

interface PackagesListProps {
  items?: any;
  addons: any;
  handleClick?: (item: any) => void;
  className?: string;
  extended?: boolean;
  foundItemId?: number;
  isExcess?: boolean;
  isReadOnly?: boolean;
}

const PackagesList: FC<PackagesListProps> = React.memo(
  ({
    items = List(),
    addons,
    extended = false,
    isExcess = false,
    className = "",
    foundItemId,
    handleClick,
    isReadOnly = false,
  }) => {
    const stopItemNavigation = (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
    };

    return (
      <ListWrapper className={className}>
        {items.map((item: any) => {
          const logo = item.get("emblem_thumb_url");
          const comment = item.get("customer_comment");
          const itemAddons = item.get("addons", List());
          // Both sides can be undefined (no search hit, or items that carry no
          // shipment_id) — without the guard every row would read as selected.
          const shipmentId = item.get("shipment_id");
          const selected = foundItemId != null && foundItemId === shipmentId;
          const decantQuantity = item.get("decant_quantity");

          const requests = item.get("service_requests_map", List());
          const hasServiceRequests = !!requests && !requests.isEmpty();
          const id = item.get("id");
          let mainDescription = item.get("description");
          if (!mainDescription) {
            mainDescription = item.get("shipment_tracking_number");
          }

          const ListItemChild = (
            <ListItem
              key={id}
              $extended={extended}
              $isReadOnly={isReadOnly}
              selected={selected}
            >
              <ItemContent onClick={() => extended && handleClick?.(item)}>
                <ItemName>
                  {logo ? (
                    <Logo image={logo} />
                  ) : (
                    <Icon type={IconType.Package} />
                  )}
                  <CopyToClipboard text={mainDescription}>
                    <TrackingNumber $isExcess={isExcess}>
                      {mainDescription}
                    </TrackingNumber>
                  </CopyToClipboard>
                  {extended && !itemAddons.isEmpty() && (
                    <AddonIcons onClick={stopItemNavigation}>
                      {getAddonsIconsImage(itemAddons, addons)}
                    </AddonIcons>
                  )}
                  {hasServiceRequests && (
                    <ServiceRequests onClick={stopItemNavigation}>
                      <ServiceTooltips
                        requests={requests.toJS()}
                        zIndex={3}
                      />
                    </ServiceRequests>
                  )}
                  {decantQuantity > 1 && (
                    <ItemQuantity>Quantity: {decantQuantity}</ItemQuantity>
                  )}
                </ItemName>
                {comment && <Comment>{comment}</Comment>}
              </ItemContent>
              {extended && handleClick && (
                <OpenItemWrapper onClick={() => handleClick(item)}>
                  <RightArrowIcon type={IconType.RightArrow} />
                </OpenItemWrapper>
              )}
            </ListItem>
          );

          if (!extended) return ListItemChild;
          return <DetailedButton key={id}>{ListItemChild}</DetailedButton>;
        })}
      </ListWrapper>
    );
  },
);

const withConnect = connect(
  createStructuredSelector({
    addons: servicesSelectAddonsAll,
  }),
  null,
);

export default withConnect(PackagesList);
